import { Component, Inject } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface SaveDialogData<T = unknown>
{
    // eslint-disable-next-line @typescript-eslint/method-signature-style
    readonly action: () => Promise<T>;
    // eslint-disable-next-line @typescript-eslint/method-signature-style
    readonly getErrorMessageFn: (error) => string;
    // eslint-disable-next-line @typescript-eslint/method-signature-style
    readonly getSuccessMessageFn: (result: T) => string;
    readonly title: string;
}

@Component({
    selector: "save-dialog-component",
    templateUrl: "./saveDialog.tmpl.html",
    standalone: false
})
export class SaveDialogComponent<T = unknown>
{
    errorMessage: string;
    errors: string;
    isSaving: boolean = true;
    result: T;
    success: boolean = false;
    successMessage: string;

    protected promise: Promise<void>;

    constructor(
        private readonly dialogRef: MatDialogRef<SaveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: SaveDialogData<T>
    )
    {
        this.promise = this.action()
            .then(
                (result: T) =>
                {
                    this.success = true;
                    this.isSaving = false;
                    this.result = result;
                    this.successMessage = this.getSuccessMessageFn(result);
                    if (!this.successMessage)
                    {
                        this.close();
                    }
                },
                (error) =>
                {
                    this.result = error;
                    if (error)
                    {
                        this.isSaving = false;
                        this.errors = !error.data ? error : error.error.Message;
                        this.errorMessage = this.getErrorMessageFn(error);
                    }
                    else
                    {
                        this.close();
                    }
                })
            .finally(() =>
            {
                this.promise = undefined;
            });
    }

    get title(): string { return this.data.title; }

    private get action(): () => Promise<T>
    {
        return this.data.action;
    }

    private get getSuccessMessageFn(): (result: T) => string
    {
        return this.data.getSuccessMessageFn;
    }

    private get getErrorMessageFn(): (error) => string
    {
        return this.data.getErrorMessageFn;
    }

    close(): void
    {
        this.success
            ? // ! TODO: Review Dialog Conversion; call expression was 'this.$mdDialog.hide(this.result).'
            this.dialogRef.close(this.result)
            : // ! TODO: Review Dialog Conversion; call expression was 'this.$mdDialog.cancel(this.result).'
            this.dialogRef.close(this.result);
    }
}
